import { render, staticRenderFns } from "./EmailSentence.vue?vue&type=template&id=4ba0e709&scoped=true"
import script from "./EmailSentence.vue?vue&type=script&lang=js"
export * from "./EmailSentence.vue?vue&type=script&lang=js"
import style0 from "./EmailSentence.vue?vue&type=style&index=0&id=4ba0e709&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba0e709",
  null
  
)

export default component.exports